// extracted by mini-css-extract-plugin
module.exports = {"summaryMainWrapper":"summary_summaryMainWrapper__2PJ6E","title":"summary_title__1d0XU","summaryWrapper":"summary_summaryWrapper__2Wxga"};